//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppCardCode from '@core/components/app-card-code/AppCardCode.vue'

// demos
import DemoDialogBasic from './demos/DemoDialogBasic.vue'
import DemoDialogPersistent from './demos/DemoDialogPersistent.vue'
import DemoDialogScrollable from './demos/DemoDialogScrollable.vue'
import DemoDialogLoader from './demos/DemoDialogLoader.vue'
import DemoDialogNesting from './demos/DemoDialogNesting.vue'
import DemoDialogOverflowed from './demos/DemoDialogOverflowed.vue'
import DemoDialogFullScreen from './demos/DemoDialogFullScreen.vue'
import DemoDialogForm from './demos/DemoDialogForm.vue'

// code
import {
  dialogBasic,
  dialogPersistent,
  dialogScrollable,
  dialogLoader,
  dialogNesting,
  dialogOverflowed,
  dialogFullScreen,
  dialogForm,
} from './demos/code'

export default {
  components: {
    AppCardCode,
    DemoDialogBasic,
    DemoDialogPersistent,
    DemoDialogScrollable,
    DemoDialogLoader,
    DemoDialogNesting,
    DemoDialogOverflowed,
    DemoDialogFullScreen,
    DemoDialogForm,
  },
  setup() {
    return {
      codeSnippets: {
        dialogBasic,
        dialogPersistent,
        dialogScrollable,
        dialogLoader,
        dialogNesting,
        dialogOverflowed,
        dialogFullScreen,
        dialogForm,
      },
    }
  },
}
